/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Maximum weight this dimension can have (between 0.0 and 1.0)
 */
export type EvaluationDimensionMaxWeight = number | null;
